import React from "react";
import ProjectAdmin from "../../Admin/Projects/projects";
import ServiceAdmin from "../../Admin/services/services";
import BlogAdmin from "../../Admin/Blog/blog";
import AboutAdminExp from "../../Admin/about/aboutExp";
import AboutAdminAch from "../../Admin/about/aboutAch";
import "./admin.css";
import FeaturedAdmin from "../../Admin/Featured/feature";
import UpdateFlag from "../../Admin/updateFlag/update";

const AdminContent = () => {
  return (
    <>
      <div className="admin-content">
        <FeaturedAdmin/>
        <BlogAdmin/>
        <AboutAdminAch/>
        <AboutAdminExp/>
        <ProjectAdmin/>
        <ServiceAdmin/>
        <UpdateFlag/>
      </div>
    </>
  );
};

export default AdminContent;
